export class CRMServicePopup {
	constructor(vroc, table, rowId) {
		this.vroc = vroc;
		this.id = 'crm-service-popup';

		let url = new URL(window.location.href);

		this.table = table;
		this.rowId = rowId;

		this.init();
	}

	async init() {
		await this.vroc.loadComponent({
			id: this.id,
			xmlUrl: `/ajax.php?mid=47&action=loadBlock&table=${this.table ?? ''}&id=${this.rowId ?? ''}`,
			templateId: 'mod_crm/popup_' + this.table,
			node: '.popup-service'
		});

		this._bindEvents();

		$('.popup-service').addClass('active');
		$("body").addClass("no-scroll");
	}

	_bindEvents() {
		
	}

	async changeSettings(form) {

		const formData = new FormData(form);
		formData.append('action', 'saveBlock');

		document.querySelector('.popup-service .loader').classList.add('active');

		const response = await fetch('/ajax.php?mid=47', {
			method: 'POST',
			body: formData
		});

		const xmlText = await response.text();
		this.vroc.updateComponent(this.id, xmlText);
	}
}